/**
 * An `object` containing the id's for each taxonomy code set
 * that is currently supported.
 */
export const TAXONOMY_SETS = {
  UNSPSC: 1,
  NAICS: 3,
};
